"use strict";
/// <reference path="./PropertyPageExtendedSearchFilter.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
const Utilities_1 = require("../../javascript/Utilities");
require("../../less/PropertyPage.less");
const VariableDialog_1 = require("./ExternalInputs/VariableDialog");
const PropertyPageControls_1 = require("./PropertyPageControls");
const PropertyPageExtendedSearch_1 = require("./PropertyPageExtendedSearch");
const Base_1 = require("../../model/Base");
let filterMarkup = require("../../templates/externalInputs/ExtendedSearchFilter.html");
(($) => {
    let methods = {
        init(options) {
            return this.each(() => {
                let $this = $(this), synData = $this.data('synPropertyPageExtendedSearchFilter');
                if (!synData) {
                    $this.trigger("beginInit");
                    synData = {
                        filter: options.filter,
                        allOperators: options.allOperators,
                        formatStrings: options.formatStrings,
                        syntaxMode: options.syntaxMode,
                        buttonControlDef: $.extend(true, options.buttonControlDef, {
                            forExternalInput: true
                        })
                    };
                    let getValueInternalFormat = function (control) {
                        switch (control.field.fieldType) {
                            case "Date":
                            case "DateTime":
                            case "Time":
                                return kendo.toString(control.getValue(), PropertyPageExtendedSearch_1.ExtendedSearchDialog.InternalDateFormat);
                            default:
                                return control.convert(control.getValue(), true);
                        }
                    };
                    let getIdInternalFormat = function (control) {
                        if (control instanceof PropertyPageControls_1.FTComboBoxControl)
                            return control.getIdString();
                        else
                            return undefined;
                    };
                    // Raised when the value of a picker has changed.
                    let onControlChange = function (left) {
                        let val = getValueInternalFormat((left ? synData.lExpressionControl : synData.rExpressionControl));
                        let id = getIdInternalFormat((left ? synData.lExpressionControl : synData.rExpressionControl));
                        if (id) {
                            synData.filter.operator[left ? "lExpression" : "rExpression"] = {
                                valueEscaped: id,
                                valueUnescaped: id,
                                valueFTField: val,
                            };
                        }
                        else {
                            synData.filter.operator[left ? "lExpression" : "rExpression"] = {
                                valueEscaped: val,
                                valueUnescaped: val,
                                valueFTField: undefined,
                            };
                        }
                    };
                    let onLeftControlChange = function () {
                        onControlChange(true);
                        updateControlSizes();
                    };
                    let onRightControlChange = function () {
                        onControlChange(false);
                        updateControlSizes();
                    };
                    let updateControlSizes = () => {
                        let filterExp = $this.find(".filterExpression");
                        let lExpressionDOM = synData.lExpressionControl.getDOMControl();
                        let rExpressionDOM = synData.rExpressionControl.getDOMControl();
                        if (filterExp.is(":visible")) {
                            let methodButtonWidth = synData.lExpressionButton ?
                                synData.lExpressionButton.getDOMControl().outerWidth(true) : 0;
                            if (lExpressionDOM.closest("div.filterExpression").is(":visible")) {
                                // binary op
                                lExpressionDOM.css("width", (175 - methodButtonWidth) + "px");
                                rExpressionDOM.css("width", (175 - methodButtonWidth) + "px");
                                $this.find(".variableExpression").css("width", "175px");
                            }
                            else if (rExpressionDOM.closest("div.filterExpression").is(":visible")) {
                                // unary op
                                rExpressionDOM.css("width", (430 - methodButtonWidth) + "px");
                                $this.find(".variableExpression").css("width", "430px");
                            }
                        }
                    };
                    let getRealOperatorType = (syntaxMode, op) => {
                        // Special case for TDExtSyntax: If value is quoted and TDExtSyntax is enabled, then the
                        // type of the operator in the GUI is "EqualsExact" or "NotEqualExact"
                        if (syntaxMode === "DefaultSyntax"
                            && (op.operatorType === "NotEqual" || op.operatorType === "Equals")) {
                            let rExp = op.rExpression;
                            let quoted = rExp.childOperator && rExp.childOperator.operatorType === "Quotes";
                            switch (op.operatorType) {
                                case "Equals":
                                    return (quoted ? "EqualsExact" : "Contains");
                                case "NotEqual":
                                    return (quoted ? "NotEqualExact" : "NotContains");
                                default: break;
                            }
                        }
                        return op.operatorType;
                    };
                    let template = kendo.template(filterMarkup);
                    $this.html(template(synData.filter));
                    let lExprDOM = $this.find(".lExpression");
                    let rExprDOM = $this.find(".rExpression");
                    lExprDOM.find("button.variableButton").addClass("lButton");
                    rExprDOM.find("button.variableButton").addClass("rButton");
                    if (options.input.enabled) {
                        let controlType = "FTComboBoxInfo";
                        if (!options.input.field.isFTField) {
                            switch (options.input.field.fieldType) {
                                case "String":
                                case "FixString":
                                    if (!options.input.field.isFTRepresentativeField)
                                        controlType = "TextBoxInfo";
                                    break;
                                case "Digit":
                                case "BigDigit":
                                case "Float":
                                    controlType = "NumericTextBoxInfo";
                                    break;
                                case "Date":
                                    controlType = "DateCtrlInfo";
                                    break;
                                case "Time":
                                    controlType = "TimeCtrlInfo";
                                    break;
                                case "DateTime":
                                    controlType = "DateAndTimeCtrlInfo";
                                    break;
                            }
                        }
                        let templateForControls = {
                            type: controlType,
                            enabled: true,
                            visible: true,
                            visibleDynamic: true,
                            key: options.controlKey,
                            width: 0,
                            height: 22,
                            tabOrder: 0,
                            field: options.input.field,
                            maxTextLength: options.input.maxTextLength,
                            readonly: false,
                            initialValue: undefined,
                            formatString: options.input.formatString,
                            forExternalInput: true,
                        };
                        let guid = Utilities_1.synUtil.getGUID(true);
                        let leftControlContainer = lExprDOM.find(".controlContainer").attr("id", guid + "_lContainer");
                        let rightControlContainer = rExprDOM.find(".controlContainer").attr("id", guid + "_rContainer");
                        let createControl = (leftControl) => {
                            let controlContainer = leftControl ?
                                lExprDOM.find(".controlContainer").attr("id", guid + "_lContainer") :
                                rExprDOM.find(".controlContainer").attr("id", guid + "_rContainer");
                            let fac = new PropertyPageControls_1.ControlFactory(controlContainer, options.currentInstance, options.typeId, options.mode, undefined, {}, undefined);
                            fac.onChange = leftControl ? onLeftControlChange : onRightControlChange;
                            fac.pushControl(templateForControls);
                            if (synData.buttonControlDef)
                                fac.pushControl(synData.buttonControlDef);
                            fac.create();
                            synData[leftControl ? "lExpressionControlFactory" : "rExpressionControlFactory"] = fac;
                            synData[leftControl ? "lExpressionControl" : "rExpressionControl"] = fac.controlCollection.allControls[0];
                            if (fac.controlCollection.allControls.length > 1) {
                                synData[leftControl ? "lExpressionButton" : "rExpressionButton"] = fac.controlCollection.allControls[1];
                                let buttonWidth = synData.buttonControlDef.methods.length > 1 ? 42 : 21;
                                synData[leftControl ? "lExpressionButton" : "rExpressionButton"].getDOMControl()
                                    .css({ width: buttonWidth + "px", height: "21px" })
                                    .find("button").css("margin-top", "-1px");
                            }
                        };
                        createControl(true);
                        createControl(false);
                        let changeOperator = function (value, updateFilterValues) {
                            switch (value.InternalName) {
                                case "IsNull":
                                case "IsNotNull": // 0-ary operator
                                    $this.find(".filterExpression").css("display", "none");
                                    delete synData.filter.operator.lExpression;
                                    delete synData.filter.operator.rExpression;
                                    delete synData.filter.operator.valueFTField;
                                    break;
                                case "Between": // Binary Operator
                                    {
                                        $this.find(".filterExpression").css("display", "");
                                        if (updateFilterValues) {
                                            setFilterValue(synData.filter.operator.rExpression, synData.lExpressionControl, false, false, false);
                                            setFilterValue(synData.filter.operator.rExpression, synData.rExpressionControl, true, false, true); // Beim Between-operator muss die alte r-Expression korrigiert werden, damit bei DateTime/Time-Feldern bei der R-Expression 23:59:59 zu stehen kommt.
                                        }
                                        let lVal = getValueInternalFormat(synData.lExpressionControl), rVal = getValueInternalFormat(synData.rExpressionControl);
                                        let lId = getIdInternalFormat(synData.lExpressionControl), rId = getIdInternalFormat(synData.rExpressionControl);
                                        // variable mode?
                                        if (lExprDOM.find("input.variableExpression:visible").length) {
                                            synData.filter.operator.lExpression
                                                = lExprDOM.find("input.variableExpression").data("expression");
                                        }
                                        else {
                                            if (lId)
                                                synData.filter.operator.lExpression = {
                                                    idEscaped: lId,
                                                    idUnescaped: lId,
                                                    valueFTField: lVal,
                                                };
                                            else
                                                synData.filter.operator.lExpression = {
                                                    valueEscaped: lVal,
                                                    valueUnescaped: lVal,
                                                    valueFTField: undefined,
                                                };
                                        }
                                        // variable mode?
                                        if (rExprDOM.find("input.variableExpression:visible").length) {
                                            synData.filter.operator.rExpression
                                                = rExprDOM.find("input.variableExpression").data("expression");
                                        }
                                        else {
                                            if (rId)
                                                synData.filter.operator.rExpression = {
                                                    valueEscaped: rId,
                                                    valueUnescaped: rId,
                                                    valueFTField: rVal,
                                                };
                                            else
                                                synData.filter.operator.rExpression = {
                                                    valueEscaped: rVal,
                                                    valueUnescaped: rVal,
                                                    valueFTField: undefined,
                                                };
                                        }
                                        break;
                                    }
                                default: // Unary operator - RExpression
                                    {
                                        lExprDOM.css("display", "none");
                                        rExprDOM.css("display", "");
                                        let unaryExpression = synData.filter.operator.rExpression;
                                        if (synData.filter.operator.lExpression) {
                                            // Da war zuvor der Between-Operator eingestellt --> hier als Ausgangspunkt die lExpression verwenden, damit der LINKE Wert, den der Benutzer
                                            // ev. verändert hat, bei der Umschaltung auf einen Unary-Operator erhalten bleibt.
                                            // Auch bei einem DateTime-Feld ist das wichtig, da ansonsten bei der Umschaltung von Between auf z.B. =-Operator beim Zeitanteil plötzlich 23:59:59
                                            // zu stehen kommt.
                                            unaryExpression = synData.filter.operator.lExpression;
                                        }
                                        if (updateFilterValues)
                                            setFilterValue(unaryExpression, synData.rExpressionControl, false, false, false);
                                        delete synData.filter.operator.lExpression;
                                        let rVal = getValueInternalFormat(synData.rExpressionControl);
                                        let rId = getIdInternalFormat(synData.rExpressionControl);
                                        // variable mode?
                                        if (rExprDOM.find("input.variableExpression:visible").length) {
                                            synData.filter.operator.rExpression
                                                = rExprDOM.find("input.variableExpression").data("expression");
                                        }
                                        else {
                                            if (rId)
                                                synData.filter.operator.rExpression = {
                                                    valueEscaped: rId,
                                                    valueUnescaped: rId,
                                                    valueFTField: rVal,
                                                };
                                            else
                                                synData.filter.operator.rExpression = {
                                                    valueEscaped: rVal,
                                                    valueUnescaped: rVal,
                                                    valueFTField: undefined,
                                                };
                                        }
                                        break;
                                    }
                            }
                            updateControlSizes();
                        };
                        let containsVariable = function (exp) {
                            if (!exp)
                                return false;
                            else {
                                if (exp.valueUnescaped)
                                    return exp.valueUnescaped.substring(0, 10) === "#variable.";
                                else if (exp.childOperator) {
                                    return containsVariable(exp.childOperator.rExpression)
                                        || containsVariable(exp.childOperator.lExpression);
                                }
                                return false;
                            }
                        };
                        let getFilterValue = function (exp) {
                            if (!exp)
                                return "";
                            else {
                                if (exp.valueUnescaped)
                                    return exp.valueUnescaped;
                                else if (exp.childOperator) {
                                    let opString = options.allOperators[exp.childOperator.operatorType].String;
                                    if (exp.childOperator.operatorType === "Quotes")
                                        return getFilterValue(exp.childOperator.rExpression);
                                    else
                                        return getFilterValue(exp.childOperator.lExpression)
                                            + opString
                                            + getFilterValue(exp.childOperator.rExpression);
                                }
                            }
                            return "";
                        };
                        let updateVariableDOM = function () {
                            let setExp = function (variableExpJQ, expression) {
                                let filterVal = getFilterValue(expression);
                                let filterValDisplay = Utilities_1.synUtil.Strings.getValue(filterVal.substring(1, filterVal.length - 1));
                                variableExpJQ.css("display", "")
                                    .val(kendo.format("★{0}★", filterValDisplay))
                                    .data("val", filterVal)
                                    .data("expression", expression);
                            };
                            if (containsVariable(synData.filter.operator.lExpression)) {
                                // lExprDOM.find(".variableButton").removeClass("inactive").addClass("active");
                                lExprDOM.find(".controlContainer").css("display", "none");
                                setExp(lExprDOM.find("input.variableExpression"), synData.filter.operator.lExpression);
                                lExprDOM.find("button.variableButton").addClass("active");
                            }
                            else {
                                // lExprDOM.find(".variableButton").removeClass("active").addClass("inactive");
                                lExprDOM.find(".controlContainer").css("display", "");
                                lExprDOM.find("input.variableExpression").css("display", "none");
                                lExprDOM.find("button.variableButton").removeClass("active");
                            }
                            if (containsVariable(synData.filter.operator.rExpression)) {
                                // rExprDOM.find(".variableButton").removeClass("inactive").addClass("active");
                                rExprDOM.find(".controlContainer").css("display", "none");
                                setExp(rExprDOM.find("input.variableExpression"), synData.filter.operator.rExpression);
                                rExprDOM.find("button.variableButton").addClass("active");
                            }
                            else {
                                // rExprDOM.find(".variableButton").removeClass("active").addClass("inactive");
                                rExprDOM.find(".controlContainer").css("display", "");
                                rExprDOM.find("input.variableExpression").css("display", "none");
                                rExprDOM.find("button.variableButton").removeClass("active");
                            }
                        };
                        // See CTDFilterVariableManager::FilterVariableFitsToFieldType()
                        let variableFitsToField = (filterVariable, field) => {
                            if ((field.isFTPresentedField) || (field.isFTRepresentativeField))
                                return filterVariable.name === "variable.currentuser";
                            else {
                                // "Normales" Feld
                                let fieldType = field.fieldType;
                                let filterVarType = filterVariable.fieldType;
                                switch (filterVarType) {
                                    case "String":
                                    case "FixString":
                                        return fieldType === "String" || fieldType === "FixString";
                                    case "Date":
                                    case "DateTime":
                                        return fieldType === "Date" || fieldType === "DateTime";
                                    case "Time":
                                        return fieldType === "Time";
                                    case "Digit":
                                    case "BigDigit":
                                        return filterVariable.name === "variable.currentuser";
                                    default:
                                        return false;
                                }
                            }
                        };
                        let setFilterValue = function (exp, control, rightExpression, initial, forceAutoCorrValue) {
                            // if (!containsVariable(exp)) {
                            switch (control.type) {
                                case "DateAndTimeCtrlInfo":
                                case "DateCtrlInfo":
                                case "TimeCtrlInfo":
                                    let fmtString = synData.formatStrings.dateTime;
                                    if (control.type === "DateCtrlInfo")
                                        fmtString = synData.formatStrings.date;
                                    else if (control.type === "TimeCtrlInfo")
                                        fmtString = synData.formatStrings.time;
                                    let dtTmp = control.getValue();
                                    if (!dtTmp)
                                        dtTmp = new Date();
                                    let bValueSet = false;
                                    if (exp) {
                                        let valTmp = exp.valueUnescaped;
                                        if (valTmp) {
                                            let tmp = kendo.parseDate(valTmp, PropertyPageExtendedSearch_1.ExtendedSearchDialog.InternalDateFormat);
                                            if (!tmp)
                                                tmp = kendo.parseDate(valTmp, fmtString);
                                            if ((!tmp) && (control.type === "DateAndTimeCtrlInfo"))
                                                // Hier kann es noch sein, dass NUR der Datumsanteil im Filter angegeben wurde
                                                tmp = kendo.parseDate(valTmp, synData.formatStrings.date);
                                            if (tmp) {
                                                dtTmp = tmp;
                                                bValueSet = true; // Hier kommt die Zeit direkt aus dem Filter --> da darf der Zeitanteil weiter unten NICHT auf 00:00 bzw. 23:59 gesetzt werden!
                                            }
                                        }
                                    }
                                    if (control.type === "TimeCtrlInfo") {
                                        if ((!bValueSet) || (forceAutoCorrValue)) {
                                            // Bei einem reinen Zeit-Feld wird die initiale Zeit auf 0 gesetzt
                                            dtTmp.setHours(0);
                                            dtTmp.setMinutes(0);
                                            dtTmp.setSeconds(0);
                                            dtTmp.setMilliseconds(0);
                                        }
                                    }
                                    else if (control.type === "DateAndTimeCtrlInfo") {
                                        if ((!bValueSet) || (forceAutoCorrValue)) {
                                            // forceAutoCorrValue=true: bewirkt an dieser Stelle, dass beim Umschalten auf den Between-operator, der Zeitanteil des R-Value auf das Ende des Tages gesetzt wird.
                                            dtTmp.setHours(rightExpression ? 23 : 0);
                                            dtTmp.setMinutes(rightExpression ? 59 : 0);
                                            dtTmp.setSeconds(rightExpression ? 59 : 0);
                                            dtTmp.setMilliseconds(rightExpression ? 999 : 0);
                                            if (rightExpression) {
                                                // Warum muss hier das Datum ev. korrigiert werden?
                                                // Wenn ein Format angegeben ist, dass Teile des Zeitanteils wegnimmt, dann muss dieser Teil auf alle Fälle auf 0 gesetzt werden.
                                                // So ist das derzeit definiert.
                                                dtTmp = Utilities_1.synUtil.timeCorrectionRegardingFormat(dtTmp, control.formatString);
                                            }
                                        }
                                    }
                                    else if (control.type === "DateCtrlInfo") {
                                        // Nur damit es sauber ist, wird hier der Zeitanteil (zur Sicherheit) auf 0 gesetzt
                                        dtTmp.setHours(0);
                                        dtTmp.setMinutes(0);
                                        dtTmp.setSeconds(0);
                                        dtTmp.setMilliseconds(0);
                                    }
                                    control.setValue(dtTmp);
                                    break;
                                case "FTComboBoxInfo":
                                    if ((exp) && (exp.valueFTField)) {
                                        let controlFactory = rightExpression ? synData.rExpressionControlFactory : synData.lExpressionControlFactory;
                                        if (controlFactory) {
                                            let fac = controlFactory;
                                            let instance = fac.instance;
                                            instance.items[options.input.field.presentedField].value = exp.valueUnescaped;
                                            instance.items[options.input.field.fieldName].value = exp.valueFTField;
                                            fac.setNewInstance(instance);
                                        }
                                        control.setValue({
                                            id: exp.valueUnescaped,
                                            value: exp.valueFTField,
                                        });
                                    }
                                    else {
                                        let controlFactory = rightExpression ? synData.rExpressionControlFactory : synData.lExpressionControlFactory;
                                        if (controlFactory) {
                                            let fac = controlFactory;
                                            let instance = fac.instance;
                                            instance.items[options.input.field.presentedField].value = "";
                                            instance.items[options.input.field.fieldName].value = "";
                                            fac.setNewInstance(instance);
                                        }
                                        control.setValue({
                                            id: "",
                                            value: "",
                                        });
                                    }
                                    break;
                                default:
                                    if (exp) {
                                        // Might be quoted string
                                        if (exp.childOperator && exp.childOperator.operatorType === "Quotes") {
                                            // control.setValue("\"" + exp.childOperator.rExpression.valueUnescaped + "\"");
                                            control.setValue(exp.childOperator.rExpression.valueUnescaped);
                                        }
                                        else {
                                            let v = control.convertBack(exp.valueUnescaped, true);
                                            control.setValue(v);
                                        }
                                    }
                                    break;
                            }
                            // }
                        };
                        updateVariableDOM();
                        let containsRExpression = containsVariable(synData.filter.operator.rExpression);
                        $this.addClass("synPropertyPageExtendedSearchFilter");
                        // $this.find(".datePicker").kendoDateTimePicker();
                        // $this.find(".datePicker").closest("span.k-datetimepicker").width(175);
                        let ddl = $this.find(".filterOpCombo").kendoDropDownList({
                            change(e) {
                                changeOperator(this.dataItem(this.select()), true);
                            },
                            dataSource: options.allowedOperators,
                            dataTextField: "Title",
                            dataValueField: "String"
                        }).data("kendoDropDownList");
                        synData.operatorCombo = ddl;
                        ddl.list.addClass("operatorComboListContainer");
                        let updateExternalOperatorButton = function (buttonSelector) {
                            let cur = buttonSelector.data("boolOperator");
                            buttonSelector.html(options.allOperators[cur].Title);
                        };
                        let toggleExternalOperatorButton = function (buttonSelector) {
                            let cur = buttonSelector.data("boolOperator");
                            cur = (cur === "And" ? "Or" : "And");
                            buttonSelector.data("boolOperator", cur);
                            synData.filter.externalOperator = cur;
                            updateExternalOperatorButton(buttonSelector);
                        };
                        if (!synData.filter.externalOperator) {
                            $this.find(".externalOperatorButton").css("visibility", "hidden");
                            $this.find(".removeButton").on("click", function () {
                                if (synData.filter.operator.lExpression) {
                                    synData.filter.operator.lExpression.valueEscaped = "";
                                    synData.filter.operator.lExpression.valueUnescaped = "";
                                    synData.filter.operator.lExpression.valueFTField = "";
                                    delete synData.filter.operator.lExpression.childOperator;
                                }
                                if (synData.filter.operator.rExpression) {
                                    synData.filter.operator.rExpression.valueEscaped = "";
                                    synData.filter.operator.rExpression.valueUnescaped = "";
                                    synData.filter.operator.rExpression.valueFTField = "";
                                    delete synData.filter.operator.rExpression.childOperator;
                                }
                                synData.lExpressionControl.setValue("");
                                synData.rExpressionControl.setValue("");
                                let ddl = $this.find("select.filterOpCombo").data("kendoDropDownList");
                                // updateFilterValues=false! Warum? Ansonsten wird der erste Filter NIE ausgeleert!
                                changeOperator(ddl.dataItem(ddl.select()), false);
                                updateVariableDOM();
                            });
                        }
                        else {
                            $this.find(".removeButton").on("click", function () {
                                $this.remove();
                            });
                            let extButton = $this.find(".externalOperatorButton");
                            extButton.data("boolOperator", synData.filter.externalOperator)
                                .on("click", function () {
                                toggleExternalOperatorButton($(this));
                            });
                            updateExternalOperatorButton(extButton);
                        }
                        ddl.select(function (dataItem) {
                            let opName = getRealOperatorType(synData.syntaxMode, synData.filter.operator);
                            return dataItem.InternalName === opName || dataItem.InternalName === opName + "Exact";
                        });
                        setFilterValue(synData.filter.operator.lExpression, synData.lExpressionControl, false, true, false);
                        setFilterValue(synData.filter.operator.rExpression, synData.rExpressionControl, synData.filter.operator.lExpression != undefined, true, false);
                        changeOperator(ddl.dataItem(ddl.select()), false);
                        let variables = $.map(options.allowedFilterVariables, (a) => {
                            if (variableFitsToField(a, options.input.field)) {
                                a.label = Utilities_1.synUtil.Strings.getValue(a.name);
                                return a;
                            }
                        });
                        if (!variables.length)
                            $this.find(".variableButton").removeClass("active").addClass("inactive");
                        else
                            $this.find(".variableButton").on("click", function () {
                                let btn = $(this);
                                let leftButton = btn.hasClass("lButton");
                                let expr = synData.filter.operator[(leftButton ? "l" : "r") + "Expression"];
                                if (btn.hasClass("active")) {
                                    // Variable button was active, revert to earlier value
                                    let tmp = expr;
                                    let lastExpression = btn.data("lastExpression");
                                    synData.filter.operator[(leftButton ? "l" : "r") + "Expression"] = lastExpression;
                                    if (!lastExpression)
                                        synData[(leftButton ? "l" : "r") + "ExpressionControl"].setValue("");
                                    btn.data("lastVariableExpression", tmp);
                                    updateVariableDOM();
                                }
                                else {
                                    let dlg = new VariableDialog_1.VariableDialog(synData.controlColl, btn.data("lastVariableExpression") || expr, variables);
                                    dlg.show((cancelled, changedInstance, additionalData) => {
                                        if (additionalData) {
                                            btn.data("lastExpression", expr);
                                            synData.filter.operator[(leftButton ? "l" : "r") + "Expression"] = additionalData;
                                            updateVariableDOM();
                                        }
                                    });
                                }
                            });
                    }
                    $this.data('synPropertyPageExtendedSearchFilter', $.extend(synData, options));
                    $this.trigger("endInit");
                }
            });
        },
        getFilter() {
            let synData = $(this).data('synPropertyPageExtendedSearchFilter');
            return synData.filter;
        },
        getFilterExpression(presented) {
            let $this = $(this), synData = $this.data('synPropertyPageExtendedSearchFilter');
            // return synData.filter;
            let lExprDOM = $this.find(".lExpression");
            let rExprDOM = $this.find(".rExpression");
            let externalOp = "";
            let extOpButton = $this.find(".externalOperatorButton");
            if (extOpButton.css("visibility") !== "hidden") {
                let eop = synData.allOperators[extOpButton.data("boolOperator")];
                if (eop.InternalName === "And" && synData.syntaxMode === "DefaultSyntax")
                    externalOp = " ";
                else
                    externalOp = eop.String;
            }
            let convertExpression = (val, fieldType) => {
                if (!val)
                    return "";
                switch (fieldType) {
                    case "Date":
                        return kendo.toString(val, synData.formatStrings.date);
                    case "DateTime": {
                        let bDateTime = true;
                        if (synData.mode === Base_1.PropertyPageMode.Search) {
                            let valAsDate = val;
                            if ((valAsDate.getHours() === 0) && (valAsDate.getMinutes() === 0) && (valAsDate.getSeconds() === 0))
                                bDateTime = false;
                        }
                        if (bDateTime)
                            return kendo.toString(val, synData.formatStrings.dateTime);
                        else
                            return kendo.toString(val, synData.formatStrings.date);
                    }
                    case "Time":
                        return kendo.toString(val, synData.formatStrings.time);
                    case "Float":
                        return val.toString().replace(/\./, synData.formatStrings.commaSeparator);
                    case "Digit":
                    case "BigDigit":
                        return val.toString();
                    case "Bool":
                        return val ? "Y" : "N";
                    default:
                        return val.toString();
                }
            };
            let lVal = "", rVal = "";
            if (lExprDOM.is(":visible")) {
                let lExprVariable = lExprDOM.find("input.variableExpression");
                if (lExprVariable.is(":visible"))
                    lVal = lExprVariable.data("val");
                else {
                    if (presented)
                        // FTComboBoxControl
                        lVal = convertExpression(synData.lExpressionControl.getIdString(), synData.lExpressionControl.field.fieldType);
                    else
                        lVal = convertExpression(synData.lExpressionControl.getValue(), synData.lExpressionControl.field.fieldType);
                }
            }
            if (rExprDOM.is(":visible")) {
                let rExprVariable = rExprDOM.find("input.variableExpression");
                if (rExprVariable.is(":visible"))
                    rVal = rExprVariable.data("val");
                else {
                    if (presented)
                        // FTComboBoxControl
                        rVal = convertExpression(synData.rExpressionControl.getIdString(), synData.rExpressionControl.field.fieldType);
                    else
                        rVal = convertExpression(synData.rExpressionControl.getValue(), synData.rExpressionControl.field.fieldType);
                }
            }
            let getQuotedFilterValue = function (input, operatorInternalName, control) {
                let isFT = control.field.isFTRepresentativeField;
                if (synData.syntaxMode === "DefaultSyntax" && !isFT && input
                    && (operatorInternalName === "EqualsExact" || operatorInternalName === "NotEqualExact"))
                    return "\"" + escapeFilterValue(input) + "\"";
                return escapeFilterValue(input);
            };
            let escapeFilterValue = function (input) {
                if (!input)
                    return "";
                // string might start with a variable, this variable must not be escaped
                let startIdx = 0;
                let variableRegex = /^#variable.[a-z0-9\.]+#/;
                let matches = variableRegex.exec(input);
                if (matches != undefined)
                    startIdx = matches[0].length;
                let result = "";
                for (let i = input.length - 1; i >= startIdx; i--) {
                    let c = input[i];
                    result = c + result;
                    if ("<|\\&>#".indexOf(c) >= 0
                        || result.indexOf("ISNULL") === 0
                        || result.indexOf("ISNOTNULL") === 0)
                        result = "\\" + result;
                }
                if (startIdx > 0)
                    result = input.substring(0, startIdx) + result;
                return result;
            };
            let op = synData.operatorCombo.dataItem(synData.operatorCombo.select());
            // Drop filter statements with missing expressions for the operator's arity.
            switch (op.InternalName) {
                case "Equal":
                case "EqualsExact":
                case "NotEqual":
                case "NotEqualExact":
                case "Contains":
                case "NotContains":
                case "Greater":
                case "Smaller":
                case "GreaterOrEqual":
                case "SmallerOrEqual":
                    if (!rVal)
                        return "";
                    break;
                case "Between":
                    if (!lVal || !rVal)
                        return "";
                    break;
            }
            return externalOp
                + getQuotedFilterValue(lVal, op.InternalName, synData.input)
                + op.String
                + getQuotedFilterValue(rVal, op.InternalName, synData.input);
        },
        destroy() {
            return this.each(() => {
                let $this = $(this), synData = $this.data('synPropertyPageExtendedSearchFilter');
                $(this).off("beginInit");
                $(this).off("initSuccess");
                $(this).off("endInit");
                $(this).off("controlsInitialized");
                $(this).off("valuesChanged");
                $(this).off("instanceChanged");
                $(this).off("needsFullRefresh");
                $this.html("");
                $this.removeData('synPropertyPageExtendedSearchFilter');
            });
        }
    };
    $.fn.synPropertyPageExtendedSearchFilter = function (method) {
        if (methods[method])
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        else if (typeof method === 'object' || !method)
            return methods.init.apply(this, arguments);
        else
            $.error('Method ' + method + ' does not exist on jQuery.synPropertyPageExtendedSearchFilter');
    };
})(jQuery);
